import { type PropsWithChildren, useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useToggle, useWindowSize } from 'react-use'
import { ChildResourceForbiddenHandler } from 'shared/child-resource-forbidden'
// TODO: [Web Platform Refactor] Fix this circular dependencie
// eslint-disable-next-line @nx/enforce-module-boundaries
import { useContaTheme } from 'shared/theming'

import { SidebarProfileMenu as NewProfileMenu } from '~/domains/home-v2/shell/sidebar/components/profile-menu.component'
import { Flex } from '~/domains/platform/design-system'
import {
  ChatWhatsAppSupportButton,
  isWhatsAppSupportButtonVisible
} from '~/domains/platform/infra/chat/components/whatsapp'
import { type Entity, type Subject } from '~/domains/platform/infra/deus-ex-machina/types'
import { logger } from '~/domains/platform/infra/monitoring/logger'
import { SettingsMenu } from '~/ui/business-components/settings/settings-menu'
import { CustomSidebar } from '~/ui/components/layouts/custom-sidebar'
import { SidebarLayout } from '~/ui/components/layouts/sidebar-layout/sidebar-layout'
import { TopBarLayout } from '~/ui/components/layouts/top-bar-layout'
import { GenericErrorMessage } from '~/ui/components/utils/generic-error-message/generic-error-message'

export interface SettingsNavigationProps {
  subject: Subject<'stone_account'>
  entity: Entity
  fullscreen?: boolean
}

export function SettingsNavigation(props: PropsWithChildren<SettingsNavigationProps>) {
  const { subject, children, entity, fullscreen = false } = props
  const theme = useContaTheme()
  const { width } = useWindowSize()
  const [open, toggleOpen] = useToggle(false)

  useEffect(() => {
    if (width >= theme.windowSizes.medium) {
      toggleOpen(true)
    }
  }, [toggleOpen, width])

  return (
    <TopBarLayout
      topBarContent={
        <Flex alignItems="center" gap="0.5rem">
          {isWhatsAppSupportButtonVisible() && <ChatWhatsAppSupportButton />}
          <SettingsMenu subject={subject} />
        </Flex>
      }
      asideContent={<CustomSidebar open={open} toggleOpen={toggleOpen} />}
    >
      <SidebarLayout open={open} aside={<NewProfileMenu entity={entity} />} fullscreen={fullscreen}>
        <ErrorBoundary
          FallbackComponent={() => <GenericErrorMessage />}
          onError={error => {
            logger(error)
          }}
        >
          <ChildResourceForbiddenHandler>{children}</ChildResourceForbiddenHandler>
        </ErrorBoundary>
      </SidebarLayout>
    </TopBarLayout>
  )
}
